// Batterie du viseur : elle se vide à chaque photo (voir game.js#shootStart) ET avec le temps de jeu, même sans
// photo. Une fois vide, l'appareil se recharge pendant un délai avant de pouvoir recommencer. Fonctions pures.

/** Secondes de jeu pour perdre une unité de batterie (une « vue ») ; Infinity si le temps ne la vide pas. */
export function drainSecondsPerUnit(batterySeconds, filmShots) {
  return batterySeconds > 0 && filmShots > 0 ? batterySeconds / filmShots : Infinity;
}

/**
 * Réglages de batterie effectifs : avec une batterie longue durée, l'autonomie est multipliée par `factor` et une photo coûte
 * `factor` fois moins (donc `factor` fois plus de photos par batterie).
 * @param {{ photoCostPercent:number, batterySeconds:number }} settings
 * @param {boolean} longLife
 * @param {number} factor
 */
export function effectiveBattery({ photoCostPercent, batterySeconds }, longLife, factor = 2) {
  return longLife
    ? { photoCostPercent: photoCostPercent / factor, batterySeconds: batterySeconds * factor }
    : { photoCostPercent, batterySeconds };
}

/**
 * Fait avancer le temps : combien d'unités la batterie perd en `dt` secondes, et le reste de temps non
 * encore compté (`carry`), à rendre au prochain appel.
 * @returns {{ units: number, carry: number }}
 */
export function stepDrain(carry, dt, secondsPerUnit) {
  if (!Number.isFinite(secondsPerUnit) || !(dt > 0)) return { units: 0, carry: Number.isFinite(secondsPerUnit) ? carry : 0 };
  const total = carry + dt;
  const units = Math.floor(total / secondsPerUnit);
  return { units, carry: total - units * secondsPerUnit };
}

/** Millisecondes de charge restantes (0 si terminée ou jamais lancée). */
export function chargeRemainingMs(chargingUntil, now) {
  return Number.isFinite(chargingUntil) ? Math.max(0, chargingUntil - now) : 0;
}

/** Durée de charge restante lisible : « 42 min » (arrondie à la minute supérieure), puis « 35 s » sous la minute. */
export function formatChargeTime(ms) {
  const seconds = Math.ceil(Math.max(0, ms) / 1000);
  return seconds >= 60 ? `${Math.ceil(seconds / 60)} min` : `${seconds} s`;
}
